import keyMirror from "keymirror";

export default keyMirror({
  SET_STATISTIC: null,
  SET_STATISTIC_SUCCESS: null,
  SET_STATISTIC_ERROR: null,
});
